import { PureComponent } from "react";
import { IStoreState } from "../../../store/states";
import { DispatchProp } from "react-redux";
import { connectRedux } from '../../../helpers/connectRedux'
import { Button, Modal, Radiobutton } from "../../../components";
import { images } from "../../../images";
import { LiteralsService } from "../../../services";
import StyledDiv from "./styles";
import { resetSingleBusStopAction, setShowSingleStopModalAction, setSingleBusStopDirectionAction,  } from "../../../store/actions";
import { IServiceInfo, IStop } from "../../../models";
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { urls } from "../../../routing";
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<any>, RouteComponentProps {
  isSingleStopModalOpen: boolean,
  singleStopSelected: IStop,
  isOrigin: boolean,
  serviceInfos: IServiceInfo[]
}

class SingleStopModal extends PureComponent<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  private handleConfirm = () => {
    const { history, location, singleStopSelected, serviceInfos } = this.props
    const stopServices = serviceInfos.filter((service) => service.stops.some((serviceStop) => serviceStop.id === singleStopSelected.id))

    if (stopServices.every((serviceInfo) => serviceInfo.roundTrips)) {
      const name = new URLSearchParams(location.search).get('name') ?? history.location.state?.name
      const lastName = new URLSearchParams(location.search).get('lastName') ?? history.location.state?.lastName
      const email = new URLSearchParams(location.search).get('email') ?? history.location.state?.email
      const townId = new URLSearchParams(location.search).get('townId') ?? history.location.state?.townId
  
      history.push(urls.newReservationDateStep, {
        userData: {
          name,
          lastName,
          email
        },
        townId: townId
      })
    }
    this.handleClose();
  }

  private handleCancel = () => {
    const { dispatch } = this.props
    dispatch(resetSingleBusStopAction())
    this.handleClose()
  }

  private handleClose = () => {
    const { dispatch } = this.props

    dispatch(setShowSingleStopModalAction(false))
  }

  private onChangeDirection = (isOrigin: boolean) => {
    const { dispatch } = this.props

    dispatch(setSingleBusStopDirectionAction(isOrigin))
  }

  public render() {
    const { isOrigin, isSingleStopModalOpen } = this.props;

    if (!isSingleStopModalOpen) return null
    return (
      <Modal isHidden={false} onOverlayClick={this.handleClose}>
        <StyledDiv>
          <header>
            <img src={images.signpost} alt="singleStopModalIcon" />
            <span> { LiteralsService.get("originOrDestination", true) }</span>
          </header>
          <section>
            <span>{ LiteralsService.get("originOrDestinationDescription", true) }</span>
            <div className="radioButtons-container">
              <Radiobutton
                label={ LiteralsService.get("origin", true) }
                selected={ isOrigin }
                onChange={ () => this.onChangeDirection(true) }
              />
              <Radiobutton
                label={ LiteralsService.get("destination", true) }
                selected={ !isOrigin }
                onChange={ () => this.onChangeDirection(false) }
              />
            </div>
          </section>
          <footer>
            <Button
              title={ LiteralsService.get('cancel') }
              styles={{ width: '100%' }}
              onPress={ this.handleCancel }
              upper
            />
            <Button
              title={ LiteralsService.get('confirm') }
              styles={{ width: '100%' }}
              onPress={ this.handleConfirm }
              upper
              filled
            />
          </footer>
        </StyledDiv>
      </Modal>
    );
  }
}

const mapStateToProps = ({ newReservation }: IStoreState) => ({
  isSingleStopModalOpen: newReservation.isSingleStopModalOpen,
  singleStopSelected: newReservation.singleStopSelected,
  isOrigin: newReservation.isOrigin,
  serviceInfos: newReservation.serviceInfos
});

export default withRouter(connectRedux(mapStateToProps, SingleStopModal as any))
